import * as React from 'react';
import { SVGProps } from 'react';

const IconRouteSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.625 7.268 11.347 9l1.987-7-6.957 2L8.22 5.853l-4.192 4.482a3.819 3.819 0 0 0 .08 5.294 3.762 3.762 0 0 0 5.467-.13l5.796-6.416a2.084 2.084 0 0 1 3.03-.072 2.116 2.116 0 0 1 0 2.978l-4.404 4.432a3.482 3.482 0 0 1 1.405 1.414l4.404-4.431a4.124 4.124 0 0 0 0-5.808 4.064 4.064 0 0 0-5.905.142l-5.796 6.415a1.783 1.783 0 0 1-2.592.062 1.81 1.81 0 0 1-.038-2.51l4.151-4.437Z" />
    <path d="M14.654 18.587a2.494 2.494 0 0 0-1.177-1.31 2.474 2.474 0 0 0-2.893.455c-.97.977-.97 2.56 0 3.536s2.543.976 3.513 0c.72-.725.906-1.784.557-2.681Z" />
  </svg>
);
export default IconRouteSizeM;
